import { CheckCircle2, Printer, IdCard, MessageCircle } from "lucide-react";
import { EVENTS } from "@/lib/reg";

const evName = (id) => {
  const e = EVENTS.find((x) => x.id === id);
  return e ? `${e.hi} (${e.en})` : id;
};
const fmtDob = (s) => s.split("-").reverse().join("/");

const shareText = (d) =>
  [
    "🏆 *ग्राम पाठशाला मानपुर* — हर गाँव एक लाइब्रेरी",
    "*हरियाणा दिवस खेल प्रतियोगिता 2026* — पंजीकरण सफल! ✅",
    "",
    `🆔 पंजीकरण संख्या: *${d.registration_id}*`,
    `👤 नाम: ${d.full_name}`,
    `👨 पिता का नाम: ${d.father_name}`,
    `🎓 कक्षा: ${d.player_class} | ${d.school}`,
    `🏃 खेल: ${d.events.map((id) => EVENTS.find((e) => e.id === id)?.hi || id).join(", ")}`,
    "",
    "📅 1 नवंबर 2026 | ⏰ सुबह 6:00 बजे",
    "📍 मानपुर स्टेडियम, मानपुर, हरियाणा",
    "🪪 आधार कार्ड साथ लाना अनिवार्य है।",
    "",
    "खेलेंगे मानपुर के युवा, बढ़ेगा गाँव का गौरव! 💪",
    `आप भी पंजीकरण करें: ${window.location.origin}`,
  ].join("\n");

const Row = ({ k, v, testid }) => (v ? (
  <div className="slip-row">
    <span className="text-slate-500">{k}</span>
    <span className="font-semibold text-navy text-right" data-testid={testid}>{v}</span>
  </div>
) : null);

export const Slip = ({ d, testid }) => (
  <div className="slip" data-testid={testid}>
    <div className="tricolour-bar" />
    <div className="p-5 sm:p-6">
      <div className="text-center">
        <div className="font-hi font-extrabold text-xl text-navy">ग्राम पाठशाला मानपुर</div>
        <div className="font-hi text-green-700 text-sm">हर गाँव एक लाइब्रेरी</div>
        <div className="mt-1 text-xs uppercase tracking-widest text-slate-500">Haryana Day Sports Meet 2026 · Registration Slip</div>
      </div>
      <div className="slip-id">
        <div className="text-[11px] uppercase tracking-widest text-slate-500">पंजीकरण संख्या · Registration ID</div>
        <div className="text-2xl sm:text-3xl font-extrabold tracking-wider text-saffron" data-testid={`${testid}-id`}>{d.registration_id}</div>
      </div>
      <Row k="नाम / Name" v={d.full_name} testid={`${testid}-name`} />
      <Row k="पिता / Father" v={d.father_name} testid={`${testid}-father`} />
      <Row k="जन्म तिथि / DOB" v={`${fmtDob(d.dob)} (${d.age_on_event_day} yrs on 1 Nov)`} />
      <Row k="कक्षा / Class" v={d.player_class} />
      <Row k="स्कूल / School" v={d.school} />
      <Row k="मोबाइल / Mobile" v={d.mobile} />
      <Row k="अभिभावक / Parent" v={d.parent_mobile} />
      <Row k="आपातकालीन / Emergency" v={d.emergency_contact} />
      <Row k="खेल / Events" v={d.events.map(evName).join(", ")} />
      <div className="mt-4 rounded-xl bg-navy text-white p-4 text-sm">
        <div className="font-hi font-semibold">1 नवंबर 2026 · सुबह 6:00 बजे · मानपुर स्टेडियम</div>
        <div className="text-white/70 text-xs mt-1">1 Nov 2026 · Reporting 6:00 AM · Manpur Stadium, Manpur, Haryana</div>
      </div>
      <div className="mt-3 flex gap-2 text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-xl p-3">
        <IdCard size={16} className="shrink-0" />
        <span className="font-hi">यह पर्ची और अपना आधार कार्ड साथ लाएँ। Bring this slip and your Aadhaar card.</span>
      </div>
    </div>
  </div>
);

export const SuccessSlip = ({ data, onNew, printOnly }) => {
  if (printOnly) return <div className="print-only"><Slip d={data} testid="printable-slip-print" /></div>;
  const shareWhatsApp = () => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText(data))}`, "_blank", "noopener");
  return (
    <section id="register" className="gp-container pb-6 scroll-mt-20" data-testid="success-modal">
      <div className="text-center mb-5 pop-in">
        <CheckCircle2 size={56} className="mx-auto text-green-400" />
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold text-white font-hi">पंजीकरण सफल!</h2>
        <p className="text-white/70">Registration successful. अपनी पंजीकरण संख्या सुरक्षित रखें।</p>
      </div>
      <div className="max-w-xl mx-auto">
        <Slip d={data} testid="printable-slip-container" />
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button onClick={shareWhatsApp} className="btn-whatsapp justify-center sm:col-span-2" data-testid="whatsapp-share-btn">
            <MessageCircle size={18} /> WhatsApp पर शेयर करें · Share on WhatsApp
          </button>
          <button onClick={() => window.print()} className="btn-saffron justify-center" data-testid="print-slip-btn">
            <Printer size={18} /> पर्ची प्रिंट / सेव करें · Print Slip
          </button>
          <button onClick={onNew} className="btn-outline justify-center !bg-transparent !text-white !border-white/60" data-testid="close-modal-btn">
            नया पंजीकरण · New Registration
          </button>
        </div>
      </div>
    </section>
  );
};
